import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { Apollo, SubscriptionResult } from 'apollo-angular';
import {
    CreateEmptyListingMutation,
    CreateEmptyListingMutationVariables,
    DeleteListingMutation,
    DeleteListingMutationVariables,
    DelistListingMutation,
    DelistListingMutationVariables,
    GetFeedbackCountQuery,
    GetFeedbackCountQueryVariables,
    GetListingByIdQuery,
    GetListingByIdQueryVariables,
    GetListingByUserIdQuery,
    GetListingByUserIdQueryVariables,
    GetListingDetailsQuery,
    GetListingDetailsQueryVariables,
    GetListingsSubscription,
    GetListingsSubscriptionVariables,
    UpdateAddressDetailsMutation,
    UpdateAddressDetailsMutationVariables,
    UpdateAddressDetailsForPaymentMutation,
    UpdateAddressDetailsForPaymentMutationVariables,
    UpdateDescriptionMutation,
    UpdateDescriptionMutationVariables,
    UpdateDetailsMutation,
    UpdateDetailsMutationVariables,
    UpdateFeaturesMutation,
    UpdatePriceMutation,
    UpdatePriceMutationVariables,
    UpdateFeaturesMutationVariables,
    GetOnboardingPropertyDetailByIdQuery,
    GetOnboardingPropertyDetailByIdQueryVariables,
    UpdateOnboardingPropertyDetailMutation,
    UpdateOnboardingPropertyDetailMutationVariables,
    Listing_Order_By,
    GetListingsWithPaginationQuery,
    GetListingsWithPaginationQueryVariables,
    GetListingsLengthSubscription,
    GetListingsLengthSubscriptionVariables,
    InsertInspectionMutation,
    InsertInspectionMutationVariables,
    SetAuctionMutation,
    SetAuctionMutationVariables,
    DeleteInspectionMutation,
    DeleteInspectionMutationVariables,
    GetListingEventsSubscription,
    GetListingEventsSubscriptionVariables,
    UpdateInspectionMutation,
    UpdateInspectionMutationVariables,
    UpdateListingStatusMutation,
    UpdateListingStatusMutationVariables,
    GetListingOwnerQuery,
    GetListingOwnerQueryVariables,
    GetListOfListingsSubscription,
    GetListOfListingsSubscriptionVariables,
    Commercial_Status_Type_Enum,
    Publishing_Status_Type_Enum,
    GetDuplicateListingsForAddressQueryQuery,
    GetDuplicateListingsForAddressQueryQueryVariables,
    GetPaidCampaignOrdersByListingIdQuery,
    GetPaidCampaignOrdersByListingIdQueryVariables,
    GetListingAddressDetailsByIdQueryQuery,
    GetListingAddressDetailsByIdQueryQueryVariables,
    GetBasicListingDetailsByIdSubscription,
    GetBasicListingDetailsByIdSubscriptionVariables,
    ReactivateListingMutationVariables,
    ReactivateListingMutation,
    GetRelistingAddonQuery,
    GetRelistingAddonQueryVariables,
    UpdateListingCommercialStatusMutationVariables,
    UpdateListingCommercialStatusMutation,
    SellListingMutationVariables,
    SellListingMutation,
    UpdateListingStatusByIdMutation,
    UpdateListingStatusByIdMutationVariables,
    RentListingMutationVariables,
    RentListingMutation,
    UnderReviewListingMutationVariables,
    UnderReviewListingMutation,
    WithdrawListingMutation,
    WithdrawListingMutationVariables,
    OnHoldListingMutation,
    OnHoldListingMutationVariables,
    UnderOfferListingMutationVariables,
    UnderOfferListingMutation,
    CheckAddonsBoughtByListingIdQuery,
    CheckAddonsBoughtByListingIdQueryVariables,
    PendingPublishListingMutation,
    PendingPublishListingMutationVariables,
    FailPublishListingMutation,
    FailPublishListingMutationVariables,
    GetListingDataQuery,
    GetListingDataQueryVariables,
    GetListingOwnerWithOnBoardQuery,
    GetListingOwnerWithOnBoardQueryVariables,
    CheckOverlappingEventsQuery,
    CheckOverlappingEventsQueryVariables,
    CheckAuctionOverlappingInspectionEventsQuery,
    CheckAuctionOverlappingInspectionEventsQueryVariables,
    Listing_Event_Type_Enum,
    ListListingMutation,
    ListListingMutationVariables,
    UpdateListingPublishingStatusMutation,
    UpdateListingPublishingStatusMutationVariables,
    InsertListingMetadataMutation,
    InsertListingMetadataMutationVariables,
    MarkListingMetadataProcessedMutation,
    MarkListingMetadataProcessedMutationVariables,
    GetNonProcessedListingMetadataQuery,
    GetNonProcessedListingMetadataQueryVariables,
    GetOpenCampaignOrdersByListingIdQuery,
    GetOpenCampaignOrdersByListingIdQueryVariables,
    Listing_Publish_Status_Insert_Input,
    Listing_Publish_Portal_Source_Enum,
    GetListingZoneQuery,
    GetListingZoneQueryVariables,
    Zone_Type,
    Zone_Type_Enum,
    GetAllListingsQuery,
    GetAllListingsQueryVariables,
    Listing_Publish_Status_Type_Enum,
    CreateEmptyListingByAdminMutation,
    CreateEmptyListingByAdminMutationVariables,
    UpdateDeliveryAddressForPaymentMutation,
    UpdateDeliveryAddressForPaymentMutationVariables,
    ListingCreatedAtQuery,
    ListingCreatedAtQueryVariables,
} from '../../generated/graphql';
import { ApolloQueryResult } from 'apollo-client';
import { AddressInputModel } from '../main/pages/wizard/address-input/address-input.model';
import { Observable } from 'rxjs';
import { PropertyDescriptionModel } from '../main/pages/wizard/property-description/property-description.model';
import { PropertyDetailsModel } from '../main/pages/wizard/property-details/property-details.model';
import { PropertyFeaturesModel } from '../main/pages/wizard/property-features/property-features.model';
import { PropertyPriceModel } from '../main/pages/wizard/property-price/property-price.model';
import { OnboardingPropertyDetail } from '../main/pages/onboarding/onboarding-step-1/step1.model';
import { FetchResult } from 'apollo-link';
import { ListingMetadata } from 'app/utils/constant';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ListingService {
    constructor(private apollo: Apollo) {}

    async createEmptyListing(): Promise<FetchResult<CreateEmptyListingMutation>> {
        const insertData: Listing_Publish_Status_Insert_Input[] = [
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Rea,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Domain,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Bmp,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Homesales,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Homely,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Allhomes,
            },
        ];
        return this.apollo
            .mutate<CreateEmptyListingMutation, CreateEmptyListingMutationVariables>({
                mutation: CREATE_EMPTY_LISTING_MUTATION,
                variables: {
                    insertPublishObject: insertData,
                },
            })
            .toPromise();
    }

    getListings(): Observable<SubscriptionResult<GetListingsSubscription>> {
        return this.apollo.subscribe<GetListingsSubscription, GetListingsSubscriptionVariables>({
            query: GET_LISTINGS_SUBSCRIPTION,
        });
    }

    async getListingUserId(listingId: string): Promise<FetchResult<GetListingOwnerQuery>> {
        return this.apollo
            .query<GetListingOwnerQuery, GetListingOwnerQueryVariables>({
                query: GET_LISTING_USER_ID_QUERY,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async getListingAddressDetailsById(
        listingId: string
    ): Promise<FetchResult<GetListingAddressDetailsByIdQueryQuery>> {
        return this.apollo
            .query<GetListingAddressDetailsByIdQueryQuery, GetListingAddressDetailsByIdQueryQueryVariables>({
                query: GET_LISTING_ADDRESS_DETAILS_BY_ID_QUERY,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async getDuplicateListingsForAddress(
        listingId: string
    ): Promise<FetchResult<GetDuplicateListingsForAddressQueryQuery>> {
        return this.apollo
            .query<GetDuplicateListingsForAddressQueryQuery, GetDuplicateListingsForAddressQueryQueryVariables>({
                query: GET_DUPLICATE_LISTINGS_FOR_ADDRESS_QUERY,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async getListingById(listingId: string): Promise<ApolloQueryResult<GetListingByIdQuery>> {
        return this.apollo
            .query<GetListingByIdQuery, GetListingByIdQueryVariables>({
                query: GET_LISTING_BY_ID_QUERY,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async getOnboardingPropertyDetailById(
        listingId: string
    ): Promise<ApolloQueryResult<GetOnboardingPropertyDetailByIdQuery>> {
        return this.apollo
            .query<GetOnboardingPropertyDetailByIdQuery, GetOnboardingPropertyDetailByIdQueryVariables>({
                query: GET_ONBOARDING_PROPERTY_DETAIL_BY_ID_QUERY,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async updateOnboardingPropertyDetail(
        listingId: string,
        detail: OnboardingPropertyDetail
    ): Promise<FetchResult<UpdateOnboardingPropertyDetailMutation>> {
        return this.apollo
            .mutate<UpdateOnboardingPropertyDetailMutation, UpdateOnboardingPropertyDetailMutationVariables>({
                mutation: UPDATE_ONBOARDING_PROPERTY_DETAIL_MUTATION,
                variables: {
                    listingId,
                    ...detail,
                },
            })
            .toPromise();
    }

    async updateAddressDetails(
        listingId: string,
        addressDetails: AddressInputModel
    ): Promise<FetchResult<UpdateAddressDetailsMutation>> {
        return this.apollo
            .mutate<UpdateAddressDetailsMutation, UpdateAddressDetailsMutationVariables>({
                mutation: UPDATE_ADDRESS_DETAILS_MUTATION,
                variables: {
                    listingId,
                    street: addressDetails.streetName,
                    streetNumber: addressDetails.streetNumber,
                    state: addressDetails.state,
                    suburb: addressDetails.suburb,
                    postcode: addressDetails.postcode,
                    unitNumber: addressDetails.unitNumber,
                    displayOption: addressDetails.displayOption,
                    lat: addressDetails.lat,
                    lon: addressDetails.lon,
                    address1: addressDetails.address1,
                    address2: addressDetails.address2,
                },
            })
            .toPromise();
    }

    async updateDescription(
        listingId: string,
        desc: PropertyDescriptionModel
    ): Promise<FetchResult<UpdateDescriptionMutation>> {
        return this.apollo
            .mutate<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>({
                mutation: UPDATE_DESCRIPTION_MUTATION,
                variables: {
                    listingId,
                    headline: desc.headline,
                    description: desc.description,
                },
            })
            .toPromise();
    }

    async deleteListing(listingId: string): Promise<FetchResult<DeleteListingMutation>> {
        return this.apollo
            .mutate<DeleteListingMutation, DeleteListingMutationVariables>({
                mutation: DELETE_LISTING_MUTATION,
                variables: { listingId },
            })
            .toPromise();
    }

    async updateDetails(listingId: string, details: PropertyDetailsModel): Promise<FetchResult<UpdateDetailsMutation>> {
        details.yearBuilt = details.yearBuilt || null;
        return this.apollo
            .mutate<UpdateDetailsMutation, UpdateDetailsMutationVariables>({
                mutation: UPDATE_DETAILS_MUTATION,
                variables: {
                    listingId,
                    ...details,
                },
            })
            .toPromise();
    }

    async updateFeatures(
        listingId: string,
        features: PropertyFeaturesModel
    ): Promise<FetchResult<UpdateFeaturesMutation>> {
        return this.apollo
            .mutate<UpdateFeaturesMutation, UpdateFeaturesMutationVariables>({
                mutation: UPDATE_FEATURES_MUTATION,
                variables: {
                    listingId,
                    features: features.toString(),
                },
            })
            .toPromise();
    }

    async updatePrice(listingId: string, price: PropertyPriceModel): Promise<void> {
        await this.apollo
            .mutate<UpdatePriceMutation, UpdatePriceMutationVariables>({
                mutation: UPDATE_PRICE_MUTATION,
                variables: {
                    listingId,
                    askingPrice: price.askingPrice || null,
                    singlePrice: price.singlePrice || null,
                    minPrice: price.minPrice || null,
                    maxPrice: price.maxPrice || null,
                    displayOption: price.displayOption || '',
                    displayText: price.displayText || null,
                    textPriceOption: price.textPriceOption || null,
                },
            })
            .toPromise();
    }

    async getListingsWithPagination(
        limit: number,
        offset: number,
        orderBy: Listing_Order_By[]
    ): Promise<ApolloQueryResult<GetListingsWithPaginationQuery>> {
        return this.apollo
            .query<GetListingsWithPaginationQuery, GetListingsWithPaginationQueryVariables>({
                query: GET_LISTINGS_WITH_PAGINATION,
                variables: {
                    offset,
                    limit,
                    orderBy,
                },
            })
            .toPromise();
    }

    getListingsLengthQuery(): Observable<SubscriptionResult<GetListingsLengthSubscription>> {
        return this.apollo.subscribe<GetListingsLengthSubscription, GetListingsLengthSubscriptionVariables>({
            query: GET_LISTINGS_LENGTH_QUERY,
        });
    }

    getListingEventsSubscription(listingId: string): Observable<SubscriptionResult<GetListingEventsSubscription>> {
        return this.apollo.subscribe<GetListingEventsSubscription, GetListingEventsSubscriptionVariables>({
            query: GET_LISTING_EVENTS_SUBSCRIPTION,
            variables: {
                listingId,
            },
        });
    }

    createInspection(
        listingId: string,
        input: InspectionInputInterface
    ): Observable<FetchResult<InsertInspectionMutation>> {
        return this.apollo.mutate<InsertInspectionMutation, InsertInspectionMutationVariables>({
            mutation: INSERT_INSPECTION,
            variables: {
                listingId,
                ...input,
            },
        });
    }

    updateInspection(
        inspectionId: string,
        input: InspectionInputInterface
    ): Observable<FetchResult<UpdateInspectionMutation>> {
        return this.apollo.mutate<UpdateInspectionMutation, UpdateInspectionMutationVariables>({
            mutation: UPDATE_INSPECTION,
            variables: {
                inspectionId,
                ...input,
            },
        });
    }

    deleteInspection(inspectionId: string): Observable<FetchResult<DeleteInspectionMutation>> {
        return this.apollo.mutate<DeleteInspectionMutation, DeleteInspectionMutationVariables>({
            mutation: DELETE_INSPECTION,
            variables: {
                inspectionId,
            },
        });
    }

    setAuction(listingId: string, input: AuctionInputInterface): Observable<FetchResult<SetAuctionMutation>> {
        return this.apollo.mutate<SetAuctionMutation, SetAuctionMutationVariables>({
            mutation: SET_AUCTION,
            variables: {
                listingId,
                ...input,
            },
        });
    }

    async updateListingStatus(userId: string, status: string): Promise<void> {
        await this.apollo
            .mutate<UpdateListingStatusMutation, UpdateListingStatusMutationVariables>({
                mutation: UPDATE_LISTING_STATUS,
                variables: {
                    userId,
                    status,
                },
            })
            .toPromise();
    }

    async getListingByUserId(userId: string): Promise<FetchResult<GetListingByUserIdQuery>> {
        return this.apollo
            .query<GetListingByUserIdQuery, GetListingByUserIdQueryVariables>({
                query: GET_LISTING_BY_USER_ID_QUERY,
                variables: {
                    userId,
                },
            })
            .toPromise();
    }

    reactivateListing(listingId: string): Promise<FetchResult<ReactivateListingMutation>> {
        return this.apollo
            .mutate<ReactivateListingMutation, ReactivateListingMutationVariables>({
                mutation: REACTIVATE_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    getListOfListings(
        commercialStatus: Commercial_Status_Type_Enum[],
        publishingStatus: Publishing_Status_Type_Enum[]
    ): Observable<SubscriptionResult<GetListOfListingsSubscription>> {
        return this.apollo.subscribe<GetListOfListingsSubscription, GetListOfListingsSubscriptionVariables>({
            query: GET_LIST_OF_LISTINGS,
            variables: {
                commercialStatus,
                publishingStatus,
            },
        });
    }

    /**
     * Returns feedback count for a given listing
     */

    async getFeedbackCountForListing(
        listingId: string,
        eventType: Listing_Event_Type_Enum
    ): Promise<ApolloQueryResult<GetFeedbackCountQuery>> {
        return this.apollo
            .query<GetFeedbackCountQuery, GetFeedbackCountQueryVariables>({
                query: GET_FEEDBACK_COUNT,
                variables: { listingId, eventType },
            })
            .toPromise();
    }

    /**
     * Returns listing details
     */

    async getListingData(listingId: string): Promise<ApolloQueryResult<GetListingDataQuery>> {
        return this.apollo
            .query<GetListingDataQuery, GetListingDataQueryVariables>({
                query: GET_LISTING_DATA,
                variables: { listingId },
            })
            .toPromise();
    }

    getListingBasicDetailsById(
        listingId: string
    ): Observable<SubscriptionResult<GetBasicListingDetailsByIdSubscription>> {
        return this.apollo.subscribe<
            GetBasicListingDetailsByIdSubscription,
            GetBasicListingDetailsByIdSubscriptionVariables
        >({
            query: GET_BASIC_LISTING_DETAILS_BY_ID,
            variables: {
                listingId,
            },
        });
    }

    async updateListingStatusById(
        listingId: string,
        status: string
    ): Promise<FetchResult<UpdateListingStatusByIdMutation>> {
        return this.apollo
            .mutate<UpdateListingStatusByIdMutation, UpdateListingStatusByIdMutationVariables>({
                mutation: UPDATE_LISTING_STATUS_BY_ID,
                variables: {
                    listingId,
                    status,
                },
            })
            .toPromise();
    }

    getPaidCampaignOrdersByListingId(listingId: string): Promise<FetchResult<GetPaidCampaignOrdersByListingIdQuery>> {
        return this.apollo
            .query<GetPaidCampaignOrdersByListingIdQuery, GetPaidCampaignOrdersByListingIdQueryVariables>({
                query: GET_PAID_CAMPAIGN_ORDERS_BY_LISTING_ID,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    getOpenCampaignOrdersByListingId(listingId: string): Promise<FetchResult<GetOpenCampaignOrdersByListingIdQuery>> {
        return this.apollo
            .query<GetOpenCampaignOrdersByListingIdQuery, GetOpenCampaignOrdersByListingIdQueryVariables>({
                query: GET_OPEN_CAMPAIGN_ORDERS_BY_LISTING_ID,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async getRelistingAddon(listingId: string): Promise<ApolloQueryResult<GetRelistingAddonQuery>> {
        return this.apollo
            .query<GetRelistingAddonQuery, GetRelistingAddonQueryVariables>({
                query: GET_RELISTING_ADDON,
                variables: { listingId },
            })
            .toPromise();
    }

    async updateListingCommercialStatus(
        listingId: string,
        commercialStatus: Commercial_Status_Type_Enum
    ): Promise<FetchResult<UpdateListingCommercialStatusMutation>> {
        return this.apollo
            .mutate<UpdateListingCommercialStatusMutation, UpdateListingCommercialStatusMutationVariables>({
                mutation: UPDATE_LISTING_COMMERCIAL_STATUS,
                variables: {
                    listingId,
                    commercialStatus,
                },
            })
            .toPromise();
    }

    async sellListing(listingId: string): Promise<FetchResult<SellListingMutation>> {
        return this.apollo
            .mutate<SellListingMutation, SellListingMutationVariables>({
                mutation: SELL_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async rentListing(listingId: string): Promise<FetchResult<RentListingMutation>> {
        return this.apollo
            .mutate<RentListingMutation, RentListingMutationVariables>({
                mutation: RENT_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async underReviewListing(listingId: string): Promise<FetchResult<UnderReviewListingMutation>> {
        return this.apollo
            .mutate<UnderReviewListingMutation, UnderReviewListingMutationVariables>({
                mutation: UNDER_REVIEW_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async withdrawListing(listingId: string): Promise<FetchResult<WithdrawListingMutation>> {
        return this.apollo
            .mutate<WithdrawListingMutation, WithdrawListingMutationVariables>({
                mutation: WITHDRAW_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async onHoldListing(listingId: string): Promise<FetchResult<OnHoldListingMutation>> {
        return this.apollo
            .mutate<OnHoldListingMutation, OnHoldListingMutationVariables>({
                mutation: ON_HOLD_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async underOfferListing(listingId: string): Promise<FetchResult<UnderOfferListingMutation>> {
        return this.apollo
            .mutate<UnderOfferListingMutation, UnderOfferListingMutationVariables>({
                mutation: UNDER_OFFER_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async listListing(listingId: string): Promise<FetchResult<ListListingMutation>> {
        return this.apollo
            .mutate<ListListingMutation, ListListingMutationVariables>({
                mutation: LIST_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async pendingPublishListing(listingId: string): Promise<FetchResult<PendingPublishListingMutation>> {
        return this.apollo
            .mutate<PendingPublishListingMutation, PendingPublishListingMutationVariables>({
                mutation: PENDING_PUBLISH_LISTING_MUTATION,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async failPublishListing(
        listingId: string,
        emailSend: boolean = false,
        message: string = ''
    ): Promise<FetchResult<FailPublishListingMutation>> {
        return this.apollo
            .mutate<FailPublishListingMutation, FailPublishListingMutationVariables>({
                mutation: FAIL_PUBLISH_LISTING_MUTATION,
                variables: {
                    listingId,
                    emailSend,
                    message,
                },
            })
            .toPromise();
    }

    async checkAddonsBoughtByListingId(
        listingId: string,
        addonIds: string[]
    ): Promise<FetchResult<CheckAddonsBoughtByListingIdQuery>> {
        return this.apollo
            .mutate<CheckAddonsBoughtByListingIdQuery, CheckAddonsBoughtByListingIdQueryVariables>({
                mutation: CHECK_ADDONS_BOUGHT_BY_LISTING_ID,
                variables: {
                    listingId,
                    addon_ids: addonIds,
                },
            })
            .toPromise();
    }

    async getListingUserWithOnBoardId(listingId: string): Promise<FetchResult<GetListingOwnerWithOnBoardQuery>> {
        return this.apollo
            .query<GetListingOwnerWithOnBoardQuery, GetListingOwnerWithOnBoardQueryVariables>({
                query: GET_LISTING_USER_ON_BOARD_ID_QUERY,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async checkOverlappingEvents(
        listingId: string,
        fromDate: string,
        toDate: string,
        listingInspectionId: string
    ): Promise<boolean> {
        return (
            (
                await this.apollo
                    .query<CheckOverlappingEventsQuery, CheckOverlappingEventsQueryVariables>({
                        query: CHECK_OVERLAPPING_EVENTS,
                        variables: {
                            listing_id: listingId,
                            from: fromDate,
                            to: toDate,
                            listing_inspection_id: listingInspectionId,
                        },
                    })
                    .toPromise()
            ).data.listing_inspection_aggregate.aggregate.count > 0
        );
    }

    async checkAuctionOverlappingInspectionEvents(listingId: string, date: string): Promise<boolean> {
        return (
            (
                await this.apollo
                    .query<
                        CheckAuctionOverlappingInspectionEventsQuery,
                        CheckAuctionOverlappingInspectionEventsQueryVariables
                    >({
                        query: CHECK_AUCTION_OVERLAPPING_INSPECTION_EVENTS,
                        variables: {
                            listing_id: listingId,
                            date,
                        },
                    })
                    .toPromise()
            ).data.listing_inspection_aggregate.aggregate.count > 0
        );
    }

    async getListingDetails(id: string): Promise<ApolloQueryResult<GetListingDetailsQuery>> {
        return this.apollo
            .query<GetListingDetailsQuery, GetListingDetailsQueryVariables>({
                query: GET_LISTING_DETAILS,
                variables: { id },
            })
            .toPromise();
    }

    async updateListingPublishingStatus(
        listingId: string,
        publishingStatus: Publishing_Status_Type_Enum
    ): Promise<FetchResult<UpdateListingPublishingStatusMutation>> {
        return this.apollo
            .mutate<UpdateListingPublishingStatusMutation, UpdateListingPublishingStatusMutationVariables>({
                mutation: UPDATE_LISTING_PUBLISHING_STATUS,
                variables: {
                    listingId,
                    publishingStatus,
                },
            })
            .toPromise();
    }

    async insertListingMetadata(
        listingId: string,
        type: ListingMetadata,
        value: string
    ): Promise<FetchResult<InsertListingMetadataMutation>> {
        return this.apollo
            .mutate<InsertListingMetadataMutation, InsertListingMetadataMutationVariables>({
                mutation: INSERT_LISTING_METADATA,
                variables: {
                    listingId,
                    type,
                    value,
                },
            })
            .toPromise();
    }

    async getListingMetadataValue(
        listingId: string,
        type: ListingMetadata
    ): Promise<GetNonProcessedListingMetadataQuery['listing_metadata'][0]> {
        return this.apollo
            .query<GetNonProcessedListingMetadataQuery, GetNonProcessedListingMetadataQueryVariables>({
                query: GET_NON_PROCESSED_LISTING_METADATA,
                variables: { listingId, type },
            })
            .pipe(map((response) => response.data.listing_metadata[0]))
            .toPromise();
    }

    async markListingMetadataAsProcessed(listingId: string, type: ListingMetadata): Promise<boolean> {
        return this.apollo
            .mutate<MarkListingMetadataProcessedMutation, MarkListingMetadataProcessedMutationVariables>({
                mutation: MARK_LISTING_METADATA_PROCESSED,
                variables: {
                    listingId,
                    type,
                },
            })
            .pipe(map((response) => (response.data.update_listing_metadata.affected_rows > 0 ? true : false)))
            .toPromise();
    }

    async updateAddressDetailsForPayment(
        listingId: string,
        addressDetails: AddressInputModel
    ): Promise<FetchResult<UpdateAddressDetailsForPaymentMutation>> {
        return this.apollo
            .mutate<UpdateAddressDetailsForPaymentMutation, UpdateAddressDetailsForPaymentMutationVariables>({
                mutation: UPDATE_ADDRESS_DETAILS_FOR_PAYMENT_MUTATION,
                variables: {
                    listingId,
                    street: addressDetails.streetName,
                    streetNumber: addressDetails.streetNumber,
                    state: addressDetails.state,
                    suburb: addressDetails.suburb,
                    postcode: addressDetails.postcode,
                    unitNumber: addressDetails.unitNumber,
                    displayOption: addressDetails.displayOption,
                    lat: addressDetails.lat,
                    lon: addressDetails.lon,
                    address1: addressDetails.address1,
                    address2: addressDetails.address2,
                },
            })
            .toPromise();
    }

    async updateDeliveryAddressForPayment(
        listingId: string,
        deliveryAddress: AddressInputModel,
        deliverToPropertyAddress: boolean
    ): Promise<FetchResult<UpdateDeliveryAddressForPaymentMutation>> {
        return this.apollo
            .mutate<UpdateDeliveryAddressForPaymentMutation, UpdateDeliveryAddressForPaymentMutationVariables>({
                mutation: UPDATE_DELIVERY_ADDRESS_FOR_PAYMENT_MUTATION,
                variables: {
                    listingId,
                    deliverToPropertyAddress,
                    street: deliveryAddress.streetName,
                    streetNumber: deliveryAddress.streetNumber,
                    state: deliveryAddress.state,
                    suburb: deliveryAddress.suburb,
                    postcode: deliveryAddress.postcode,
                    unitNumber: deliveryAddress.unitNumber,
                    lat: deliveryAddress.lat,
                    lon: deliveryAddress.lon,
                    address1: deliveryAddress.address1,
                    address2: deliveryAddress.address2,
                },
            })
            .toPromise();
    }

    async deListFromAllportals(listingId: string): Promise<void> {
        await this.apollo
            .mutate<DelistListingMutation, DelistListingMutationVariables>({
                mutation: DELIST_LISTING,
                variables: {
                    listingId,
                },
            })
            .toPromise();
    }

    async getListingZone(listingId: string): Promise<Zone_Type_Enum> {
        const resp = await this.apollo
            .query<GetListingZoneQuery, GetListingZoneQueryVariables>({
                query: GET_LISTING_ZONE,
                variables: { listingId },
            })
            .toPromise();
        return resp.data.listing_by_pk.zone;
    }

    async getAllListings(): Promise<GetAllListingsQuery['listing']> {
        return this.apollo
            .query<GetAllListingsQuery, GetAllListingsQueryVariables>({
                query: GET_ALL_LISTINGS,
                variables: {},
            })
            .pipe(map((res) => res.data.listing))
            .toPromise();
    }

    /**
     * Returns string date from listing.created_at, or empty string
     * @param listingId
     */
    async listingCreatedAt(listingId: string): Promise<string> {
        return this.apollo
            .query<ListingCreatedAtQuery, ListingCreatedAtQueryVariables>({
                query: LISTING_CREATED_AT,
                variables: {
                    listingId,
                },
            })
            .pipe(
                map((res) => {
                    return res.data.listing_by_pk.created_at || '';
                })
            )
            .toPromise();
    }

    async createEmptyListingByAdmin(ownerId: string): Promise<FetchResult<CreateEmptyListingByAdminMutation>> {
        const portalStatuses: Listing_Publish_Status_Insert_Input[] = [
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Rea,
                publish_status: Listing_Publish_Status_Type_Enum.Draft,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Domain,
                publish_status: Listing_Publish_Status_Type_Enum.Draft,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Bmp,
                publish_status: Listing_Publish_Status_Type_Enum.Draft,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Homesales,
                publish_status: Listing_Publish_Status_Type_Enum.Draft,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Homely,
                publish_status: Listing_Publish_Status_Type_Enum.Draft,
            },
            {
                portal_source: Listing_Publish_Portal_Source_Enum.Allhomes,
                publish_status: Listing_Publish_Status_Type_Enum.Draft,
            },
        ];
        return this.apollo
            .mutate<CreateEmptyListingByAdminMutation, CreateEmptyListingByAdminMutationVariables>({
                mutation: CREATE_EMPTY_LISTING_BY_ADMIN_MUTATION,
                variables: {
                    ownerId,
                    portalStatuses,
                },
            })
            .toPromise();
    }
}

export interface InspectionInputInterface {
    from?: string;
    to?: string;
    isPrivate?: boolean;
    repeat?: boolean;
}

export interface AuctionInputInterface {
    timestamp?: string;
    isOnline?: boolean;
}

//
// Queries
//

const GET_LISTING_ZONE = gql`
    query getListingZone($listingId: uuid!) {
        listing_by_pk(id: $listingId) {
            zone
        }
    }
`;
const GET_LISTING_BY_ID_QUERY = gql`
    query getListingById($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            id
            summary
            description
            propertyDetails_address_1
            propertyDetails_address_2
            propertyDetails_address_street
            propertyDetails_address_streetNumber
            propertyDetails_address_state
            propertyDetails_address_suburb
            propertyDetails_address_municipality
            propertyDetails_address_postcode
            propertyDetails_address_unitNumber
            propertyDetails_address_displayOption
            propertyDetails_address_streetDirectory_page
            propertyDetails_address_streetDirectory_type
            propertyDetails_address_streetDirectory_reference
            propertyDetails_address_suggestedGeoLocation
            propertyDetails_address_suggestedGeoLocation_latitude
            propertyDetails_address_suggestedGeoLocation_longitude
            delivery_address_1
            delivery_address_2
            delivery_address_street
            delivery_address_streetNumber
            delivery_address_state
            delivery_address_suburb
            delivery_address_postcode
            delivery_address_unitNumber
            delivery_address_suggestedGeoLocation_latitude
            delivery_address_suggestedGeoLocation_longitude
            delivery_to_property_address
            propertyDetails_propertyType
            propertyDetails_bedRooms
            propertyDetails_bathRooms
            propertyDetails_landArea_unit
            propertyDetails_landArea_value
            propertyDetails_area_value
            propertyDetails_area_unit
            propertyDetails_carSpaces
            availableFrom
            saleType
            propertyDetails_yearBuilt
            features
            price_asking
            price_single
            price_from
            price_to
            price_displayOption
            price_displayText
            price_textOption
            created_at
            updated_at
            status
            auction_dateTime
            auction_online
            commercial_status
            publishing_status
            proof_of_ownership_status
            propertyDetails_garageSpaces
            propertyDetails_carportSpaces
            propertyDetails_energyEfficiencyRating
            listing_inspections {
                id
                from
                to
                is_private
                repeat
            }
            user {
                id
                phone_number
                phone_number_verified
            }
            paidOrders: orders(
                where: { _and: [{ order_items: { campaign: { id: { _is_null: false } } } }, { status: { _eq: Paid } }] }
            ) {
                id
                status
            }
        }
    }
`;

const GET_BASIC_LISTING_DETAILS_BY_ID = gql`
    subscription getBasicListingDetailsById($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            id
            summary
            status
            commercial_status
            publishing_status
            saleType
            proof_of_ownership_status
            propertyDetails_address_state
            paidOrders: orders(
                where: { _and: [{ order_items: { campaign: { id: { _is_null: false } } } }, { status: { _eq: Paid } }] }
            ) {
                id
                status
                order_items(where: { campaign: { id: { _is_null: false } } }) {
                    campaign_id
                }
            }
            openOrders: orders(
                where: {
                    _and: [
                        {
                            order_items: {
                                _or: [{ campaign: { id: { _is_null: false } } }, { addon: { id: { _is_null: false } } }]
                            }
                        }
                        { status: { _eq: Open } }
                    ]
                }
            ) {
                id
                status
                order_items {
                    campaign_id
                    addon_id
                }
            }
            listing_media(where: { type: { _eq: STATEMENT_OF_INFORMATION }, url: { _is_null: false } }) {
                id
            }
        }
    }
`;

const GET_LISTINGS_SUBSCRIPTION = gql`
    subscription getListings {
        listing {
            id
            enquiry_code
            propertyDetails_address_street
            propertyDetails_address_streetNumber
            propertyDetails_address_state
            propertyDetails_address_suburb
            propertyDetails_address_municipality
            propertyDetails_address_postcode
            propertyDetails_address_unitNumber
            propertyDetails_address_displayOption
            propertyDetails_address_streetDirectory_page
            propertyDetails_address_streetDirectory_type
            propertyDetails_address_streetDirectory_reference
            propertyDetails_address_suggestedGeoLocation
            propertyDetails_address_suggestedGeoLocation_latitude
            propertyDetails_address_suggestedGeoLocation_longitude
            status
            created_at
            updated_at
            commercial_status
            paidOrders: orders(
                where: { _and: [{ order_items: { campaign: { id: { _is_null: false } } } }, { status: { _eq: Paid } }] }
            ) {
                id
                status
            }
        }
    }
`;

const GET_ONBOARDING_PROPERTY_DETAIL_BY_ID_QUERY = gql`
    query getOnboardingPropertyDetailById($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            id
            saleType
            propertyDetails_propertyType
            propertyDetails_bedRooms
            propertyDetails_landArea_unit
            propertyDetails_landArea_value
            propertyDetails_address_suburb
            propertyDetails_address_state
            propertyDetails_address_postcode
        }
    }
`;

const UPDATE_ONBOARDING_PROPERTY_DETAIL_MUTATION = gql`
    mutation updateOnboardingPropertyDetail(
        $listingId: uuid!
        $saleType: String
        $propertyType: String
        $bedrooms: Int
        $landArea: numeric
        $landAreaUnit: String
        $suburb: String
        $state: String
        $postCode: String
    ) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: {
                saleType: $saleType
                propertyDetails_propertyType: $propertyType
                propertyDetails_bedRooms: $bedrooms
                propertyDetails_landArea_value: $landArea
                propertyDetails_landArea_unit: $landAreaUnit
                propertyDetails_address_suburb: $suburb
                propertyDetails_address_state: $state
                propertyDetails_address_postcode: $postCode
                propertyDetails_address_suburb_before_checkout: $suburb
                propertyDetails_address_state_before_checkout: $state
                propertyDetails_address_postcode_before_checkout: $postCode
            }
        ) {
            affected_rows
        }
    }
`;

const CREATE_EMPTY_LISTING_MUTATION = gql`
    mutation createEmptyListing($insertPublishObject: [listing_publish_status_insert_input!]!) {
        insert_listing(objects: { listing_publish_statuses: { data: $insertPublishObject } }) {
            affected_rows
            returning {
                id
                created_at
            }
        }
    }
`;

const DELETE_LISTING_MUTATION = gql`
    mutation deleteListing($listingId: uuid!) {
        delete_listing(where: { id: { _eq: $listingId } }) {
            affected_rows
        }
    }
`;

const UPDATE_ADDRESS_DETAILS_MUTATION = gql`
    mutation updateAddressDetails(
        $listingId: uuid!
        $street: String
        $streetNumber: String
        $state: String
        $suburb: String
        $postcode: String
        $unitNumber: String
        $displayOption: String
        $lat: numeric
        $lon: numeric
        $address1: String
        $address2: String
    ) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: {
                propertyDetails_address_1: $address1
                propertyDetails_address_2: $address2
                propertyDetails_address_street: $street
                propertyDetails_address_streetNumber: $streetNumber
                propertyDetails_address_state: $state
                propertyDetails_address_suburb: $suburb
                propertyDetails_address_postcode: $postcode
                propertyDetails_address_unitNumber: $unitNumber
                propertyDetails_address_displayOption: $displayOption
                propertyDetails_address_suggestedGeoLocation_latitude: $lat
                propertyDetails_address_suggestedGeoLocation_longitude: $lon
                propertyDetails_address_state_before_checkout: $state
                propertyDetails_address_suburb_before_checkout: $suburb
                propertyDetails_address_postcode_before_checkout: $postcode
            }
        ) {
            affected_rows
        }
    }
`;

const UPDATE_ADDRESS_DETAILS_FOR_PAYMENT_MUTATION = gql`
    mutation updateAddressDetailsForPayment(
        $listingId: uuid!
        $street: String
        $streetNumber: String
        $state: String
        $suburb: String
        $postcode: String
        $unitNumber: String
        $displayOption: String
        $lat: numeric
        $lon: numeric
        $address1: String
        $address2: String
    ) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: {
                propertyDetails_address_1: $address1
                propertyDetails_address_2: $address2
                propertyDetails_address_street: $street
                propertyDetails_address_streetNumber: $streetNumber
                propertyDetails_address_state: $state
                propertyDetails_address_suburb: $suburb
                propertyDetails_address_postcode: $postcode
                propertyDetails_address_unitNumber: $unitNumber
                propertyDetails_address_displayOption: $displayOption
                propertyDetails_address_suggestedGeoLocation_latitude: $lat
                propertyDetails_address_suggestedGeoLocation_longitude: $lon
            }
        ) {
            affected_rows
        }
    }
`;

const UPDATE_DELIVERY_ADDRESS_FOR_PAYMENT_MUTATION = gql`
    mutation updateDeliveryAddressForPayment(
        $listingId: uuid!
        $street: String
        $streetNumber: String
        $state: String
        $suburb: String
        $postcode: String
        $unitNumber: String
        $lat: numeric
        $lon: numeric
        $address1: String
        $address2: String
        $deliverToPropertyAddress: Boolean!
    ) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: {
                delivery_to_property_address: $deliverToPropertyAddress
                delivery_address_1: $address1
                delivery_address_2: $address2
                delivery_address_street: $street
                delivery_address_streetNumber: $streetNumber
                delivery_address_state: $state
                delivery_address_suburb: $suburb
                delivery_address_postcode: $postcode
                delivery_address_unitNumber: $unitNumber
                delivery_address_suggestedGeoLocation_latitude: $lat
                delivery_address_suggestedGeoLocation_longitude: $lon
            }
        ) {
            affected_rows
        }
    }
`;

const GET_LISTING_USER_ID_QUERY = gql`
    query GetListingOwner($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            paidOrders: orders(where: { status: { _eq: Paid } }) {
                id
            }
            user {
                id
                email_verified
            }
        }
    }
`;

const GET_LISTINGS_WITH_PAGINATION = gql`
    query getListingsWithPagination($limit: Int!, $offset: Int!, $orderBy: [listing_order_by!]) {
        listing(limit: $limit, offset: $offset, order_by: $orderBy) {
            id
            status
            propertyDetails_address_state
            propertyDetails_address_postcode
            propertyDetails_address_suburb
            proof_of_ownership_status
            user {
                id
                email
            }
        }
    }
`;

const GET_LISTINGS_LENGTH_QUERY = gql`
    subscription getListingsLength {
        listing_aggregate {
            aggregate {
                count
            }
        }
    }
`;

const GET_LISTING_ADDRESS_DETAILS_BY_ID_QUERY = gql`
    query getListingAddressDetailsByIdQuery($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            id
            propertyDetails_address_street
            propertyDetails_address_streetNumber
            propertyDetails_address_state
            propertyDetails_address_suburb
            propertyDetails_address_postcode
            propertyDetails_address_unitNumber
            saleType
        }
    }
`;

const GET_DUPLICATE_LISTINGS_FOR_ADDRESS_QUERY = gql`
    query getDuplicateListingsForAddressQuery($listingId: String!) {
        check_duplicate_listing_for_address(listingId: $listingId) {
            duplicate
        }
    }
`;

const UPDATE_DESCRIPTION_MUTATION = gql`
    mutation updateDescription($listingId: uuid!, $headline: String!, $description: String!) {
        update_listing(where: { id: { _eq: $listingId } }, _set: { summary: $headline, description: $description }) {
            affected_rows
        }
    }
`;

const UPDATE_LISTING_STATUS = gql`
    mutation updateListingStatus($userId: uuid!, $status: String) {
        update_listing(where: { user: { id: { _eq: $userId } } }, _set: { status: $status }) {
            affected_rows
        }
    }
`;

const UPDATE_DETAILS_MUTATION = gql`
    mutation updateDetails(
        $listingId: uuid!
        $saleType: String!
        $propertyType: String!
        $bedrooms: Int
        $bathrooms: Int
        $availableFrom: timestamptz
        $landArea: numeric
        $landAreaUnit: String
        $propertyArea: numeric
        $propertyAreaUnit: String
        $carSpaces: Int
        $yearBuilt: Int
        $garageSpaces: Int
        $carportSpaces: Int
        $energyRating: numeric
    ) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: {
                saleType: $saleType
                propertyDetails_propertyType: $propertyType
                propertyDetails_bedRooms: $bedrooms
                propertyDetails_bathRooms: $bathrooms
                availableFrom: $availableFrom
                propertyDetails_landArea_value: $landArea
                propertyDetails_landArea_unit: $landAreaUnit
                propertyDetails_area_value: $propertyArea
                propertyDetails_area_unit: $propertyAreaUnit
                propertyDetails_carSpaces: $carSpaces
                propertyDetails_yearBuilt: $yearBuilt
                propertyDetails_garageSpaces: $garageSpaces
                propertyDetails_carportSpaces: $carportSpaces
                propertyDetails_energyEfficiencyRating: $energyRating
            }
        ) {
            affected_rows
        }
    }
`;

const UPDATE_FEATURES_MUTATION = gql`
    mutation updateFeatures($listingId: uuid!, $features: String!) {
        update_listing(where: { id: { _eq: $listingId } }, _set: { features: $features }) {
            affected_rows
        }
    }
`;

const UPDATE_PRICE_MUTATION = gql`
    mutation updatePrice(
        $listingId: uuid!
        $askingPrice: Int
        $singlePrice: Int!
        $minPrice: Int
        $maxPrice: Int
        $displayText: String
        $displayOption: String!
        $textPriceOption: String
    ) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: {
                price_asking: $askingPrice
                price_single: $singlePrice
                price_from: $minPrice
                price_to: $maxPrice
                price_displayText: $displayText
                price_displayOption: $displayOption
                price_textOption: $textPriceOption
            }
        ) {
            affected_rows
        }
    }
`;

const INSERT_INSPECTION = gql`
    mutation insertInspection(
        $listingId: uuid!
        $from: timestamptz
        $to: timestamptz
        $isPrivate: Boolean
        $repeat: Boolean
    ) {
        insert_listing_inspection(
            objects: [{ from: $from, to: $to, listing_id: $listingId, repeat: $repeat, is_private: $isPrivate }]
        ) {
            returning {
                id
                from
                to
                repeat
                is_private
            }
        }
    }
`;

const UPDATE_INSPECTION = gql`
    mutation updateInspection(
        $inspectionId: uuid!
        $from: timestamptz
        $to: timestamptz
        $isPrivate: Boolean
        $repeat: Boolean
    ) {
        update_listing_inspection(
            where: { id: { _eq: $inspectionId } }
            _set: { from: $from, to: $to, is_private: $isPrivate, repeat: $repeat }
        ) {
            returning {
                id
                from
                to
                is_private
                repeat
            }
        }
    }
`;

const DELETE_INSPECTION = gql`
    mutation deleteInspection($inspectionId: uuid!) {
        delete_listing_inspection(where: { id: { _eq: $inspectionId } }) {
            affected_rows
        }
    }
`;

const SET_AUCTION = gql`
    mutation setAuction($listingId: uuid!, $timestamp: timestamptz, $isOnline: Boolean) {
        update_listing(
            where: { id: { _eq: $listingId } }
            _set: { auction_dateTime: $timestamp, auction_online: $isOnline }
        ) {
            returning {
                id
                auction_dateTime
                auction_online
            }
        }
    }
`;

const GET_LISTING_EVENTS_SUBSCRIPTION = gql`
    subscription getListingEvents($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            id
            auction_dateTime
            auction_online
            listing_inspections(order_by: { from: asc }) {
                id
                from
                to
                is_private
                repeat
            }
        }
    }
`;

const GET_LISTING_BY_USER_ID_QUERY = gql`
    query getListingByUserId($userId: uuid!) {
        listing(where: { owner_id: { _eq: $userId } }) {
            id
        }
    }
`;

const GET_LIST_OF_LISTINGS = gql`
    subscription getListOfListings(
        $commercialStatus: [commercial_status_type_enum!]
        $publishingStatus: [publishing_status_type_enum!]
    ) {
        listing(
            where: {
                _and: { commercial_status: { _in: $commercialStatus }, publishing_status: { _in: $publishingStatus } }
            }
            order_by: { updated_at: desc }
        ) {
            id
            price_displayText
            enquiry_code
            propertyDetails_area_value
            propertyDetails_area_unit
            propertyDetails_bathRooms
            propertyDetails_bedRooms
            propertyDetails_carSpaces
            propertyDetails_propertyType
            propertyDetails_landArea_value
            propertyDetails_landArea_unit
            propertyDetails_address_streetNumber
            propertyDetails_address_unitNumber
            propertyDetails_address_street
            propertyDetails_address_1
            propertyDetails_address_2
            propertyDetails_address_displayOption
            propertyDetails_address_state
            propertyDetails_address_suburb
            propertyDetails_address_postcode
            saleType
            price_displayText
            price_textOption
            price_displayOption
            price_single
            price_from
            price_to
            price_asking
            commercial_status
            publishing_status
            proof_of_ownership_status
            auction_dateTime
            availableFrom
            summary
            description
            features
            owner_id
            propertyDetails_garageSpaces
            propertyDetails_carportSpaces
            propertyDetails_energyEfficiencyRating
            listing_media(order_by: { order: asc }, limit: 1) {
                id
                url
            }
            listing_onboardings {
                finished
                skipped
            }
            user {
                phone_number_verified
            }
            listing_inspections {
                id
            }
            paidOrders: orders(
                where: { _and: [{ order_items: { campaign: { id: { _is_null: false } } } }, { status: { _eq: Paid } }] }
            ) {
                id
            }
            feedbacks_aggregate {
                aggregate {
                    count
                }
            }
            visitedPreview: listing_events_aggregate(where: { event_type: { _eq: visited_preview } }) {
                aggregate {
                    count
                }
            }
            visitedCampaign: listing_events_aggregate(where: { event_type: { _eq: visited_campaign } }) {
                aggregate {
                    count
                }
            }
        }
    }
`;

const UPDATE_LISTING_STATUS_BY_ID = gql`
    mutation updateListingStatusById($listingId: uuid!, $status: String) {
        update_listing(where: { id: { _eq: $listingId } }, _set: { status: $status }) {
            affected_rows
        }
    }
`;

const GET_PAID_CAMPAIGN_ORDERS_BY_LISTING_ID = gql`
    query getPaidCampaignOrdersByListingId($listingId: uuid!) {
        order(
            where: {
                listing_id: { _eq: $listingId }
                status: { _eq: Paid }
                order_items: { campaign_id: { _is_null: false } }
            }
        ) {
            id
            order_items(where: { campaign_id: { _is_null: false } }) {
                campaign_id
                campaign {
                    code
                }
            }
        }
    }
`;

const GET_OPEN_CAMPAIGN_ORDERS_BY_LISTING_ID = gql`
    query getOpenCampaignOrdersByListingId($listingId: uuid!) {
        order(
            where: {
                listing_id: { _eq: $listingId }
                order_items: { campaign_id: { _is_null: false } }
                status: { _eq: Open }
            }
        ) {
            id
            created_from_template
            order_items {
                campaign_id
                campaign {
                    code
                }
            }
        }
    }
`;

const GET_FEEDBACK_COUNT = gql`
    query getFeedbackCount($listingId: uuid!, $eventType: listing_event_type_enum) {
        feedback_aggregate(where: { _and: { listing_id: { _eq: $listingId }, event_type: { _eq: $eventType } } }) {
            aggregate {
                count
            }
        }
    }
`;

const REACTIVATE_LISTING_MUTATION = gql`
    mutation reactivateListing($listingId: uuid!) {
        reactivate_listing(listingId: $listingId) {
            updated
        }
    }
`;

const GET_RELISTING_ADDON = gql`
    query getRelistingAddon($listingId: String!) {
        get_relisting_addon(listingId: $listingId) {
            id
            price
        }
    }
`;

const UPDATE_LISTING_COMMERCIAL_STATUS = gql`
    mutation updateListingCommercialStatus($listingId: uuid!, $commercialStatus: commercial_status_type_enum!) {
        update_listing(where: { id: { _eq: $listingId } }, _set: { commercial_status: $commercialStatus }) {
            affected_rows
        }
    }
`;

const SELL_LISTING_MUTATION = gql`
    mutation sellListing($listingId: uuid!) {
        sell_listing(listingId: $listingId) {
            updated
        }
    }
`;

const RENT_LISTING_MUTATION = gql`
    mutation rentListing($listingId: uuid!) {
        rent_listing(listingId: $listingId) {
            updated
        }
    }
`;

const UNDER_REVIEW_LISTING_MUTATION = gql`
    mutation underReviewListing($listingId: uuid!) {
        under_review_listing(listingId: $listingId) {
            updated
        }
    }
`;

const WITHDRAW_LISTING_MUTATION = gql`
    mutation withdrawListing($listingId: uuid!) {
        withdraw_listing(listingId: $listingId) {
            updated
        }
    }
`;

const ON_HOLD_LISTING_MUTATION = gql`
    mutation onHoldListing($listingId: uuid!) {
        on_hold_listing(listingId: $listingId) {
            updated
        }
    }
`;

const UNDER_OFFER_LISTING_MUTATION = gql`
    mutation underOfferListing($listingId: uuid!) {
        under_offer_listing(listingId: $listingId) {
            updated
        }
    }
`;

const LIST_LISTING_MUTATION = gql`
    mutation listListing($listingId: uuid!) {
        list_listing(listingId: $listingId) {
            updated
        }
    }
`;

const CHECK_ADDONS_BOUGHT_BY_LISTING_ID = gql`
    query checkAddonsBoughtByListingId($listingId: uuid!, $addon_ids: [uuid!]) {
        order_item(
            where: {
                order: { listing_id: { _eq: $listingId }, status: { _eq: Paid } }
                addon_id: { _is_null: false, _in: $addon_ids }
            }
        ) {
            addon {
                id
            }
        }
    }
`;

const GET_LISTING_DATA = gql`
    query getListingData($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            saleType
            commercial_status
            publishing_status
            auction_dateTime
            proof_of_ownership_status
            user {
                phone_number_verified
            }
            listing_inspections {
                id
            }
        }
    }
`;

const FAIL_PUBLISH_LISTING_MUTATION = gql`
    mutation failPublishListing($listingId: uuid!, $emailSend: Boolean, $message: String) {
        fail_publish_listing(listingId: $listingId, emailSend: $emailSend, message: $message) {
            updated
        }
    }
`;

const PENDING_PUBLISH_LISTING_MUTATION = gql`
    mutation pendingPublishListing($listingId: uuid!) {
        pending_publish_listing(listingId: $listingId) {
            updated
        }
    }
`;

const GET_LISTING_USER_ON_BOARD_ID_QUERY = gql`
    query GetListingOwnerWithOnBoard($listingId: uuid!) {
        listing(where: { id: { _eq: $listingId } }) {
            user {
                id
            }
            listing_onboardings {
                id
                finished
                skipped
                step_completed
                user_id
            }
        }
    }
`;

const CHECK_OVERLAPPING_EVENTS = gql`
    query checkOverlappingEvents(
        $listing_id: uuid!
        $from: timestamptz!
        $to: timestamptz!
        $listing_inspection_id: uuid
    ) {
        listing_inspection_aggregate(
            where: {
                _and: {
                    listing_id: { _eq: $listing_id }
                    _or: [
                        { listing: { auction_dateTime: { _gte: $from, _lt: $to } } }
                        {
                            id: { _neq: $listing_inspection_id }
                            _or: [
                                { listing: { auction_dateTime: { _gt: $from, _lt: $to } } }
                                { _and: { from: { _lt: $from }, to: { _gt: $from } } }
                                { _and: { from: { _lt: $to }, to: { _gt: $to } } }
                                { _and: { from: { _gt: $from, _lt: $to } } }
                                { _and: { to: { _gt: $from, _lt: $to } } }
                            ]
                        }
                    ]
                }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;

const CHECK_AUCTION_OVERLAPPING_INSPECTION_EVENTS = gql`
    query checkAuctionOverlappingInspectionEvents($listing_id: uuid!, $date: timestamptz!) {
        listing_inspection_aggregate(
            where: {
                _and: { listing_id: { _eq: $listing_id }, _and: [{ from: { _lte: $date } }, { to: { _gt: $date } }] }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;

const GET_LISTING_DETAILS = gql`
    query getListingDetails($id: uuid!) {
        listing(where: { id: { _eq: $id } }) {
            id
            propertyDetails_bathRooms
            propertyDetails_bedRooms
            propertyDetails_carSpaces
            propertyDetails_propertyType
            propertyDetails_landArea_value
            propertyDetails_address_streetNumber
            propertyDetails_address_unitNumber
            propertyDetails_address_street
            propertyDetails_address_displayOption
            propertyDetails_address_state
            propertyDetails_address_suburb
            propertyDetails_address_postcode
            saleType
            commercial_status
            publishing_status
            proof_of_ownership_status
            auction_dateTime
            availableFrom
            features
            description
            summary
            price_asking
            propertyDetails_garageSpaces
            propertyDetails_carportSpaces
            propertyDetails_energyEfficiencyRating
            listing_media(order_by: { order: asc }, limit: 1) {
                id
                url
            }
            listing_onboardings {
                finished
                skipped
            }
            user {
                phone_number_verified
            }
            listing_inspections {
                id
            }
            paidOrders: orders(
                where: { _and: [{ order_items: { campaign: { id: { _is_null: false } } } }, { status: { _eq: Paid } }] }
            ) {
                id
            }
            visitedPreview: listing_events_aggregate(where: { event_type: { _eq: visited_preview } }) {
                aggregate {
                    count
                }
            }
            visitedCampaign: listing_events_aggregate(where: { event_type: { _eq: visited_campaign } }) {
                aggregate {
                    count
                }
            }
        }
    }
`;

const UPDATE_LISTING_PUBLISHING_STATUS = gql`
    mutation updateListingPublishingStatus($listingId: uuid!, $publishingStatus: publishing_status_type_enum!) {
        update_listing(where: { id: { _eq: $listingId } }, _set: { publishing_status: $publishingStatus }) {
            affected_rows
        }
    }
`;

const INSERT_LISTING_METADATA = gql`
    mutation insertListingMetadata($listingId: uuid!, $type: String, $value: String) {
        insert_listing_metadata_one(
            object: { listing_id: $listingId, type: $type, value: $value, is_processed: false }
        ) {
            id
        }
    }
`;

const GET_NON_PROCESSED_LISTING_METADATA = gql`
    query getNonProcessedListingMetadata($listingId: uuid!, $type: String) {
        listing_metadata(
            where: { is_processed: { _eq: false }, type: { _eq: $type }, listing_id: { _eq: $listingId } }
            order_by: { created_at: desc }
        ) {
            value
            listing {
                saleType
            }
        }
    }
`;

const MARK_LISTING_METADATA_PROCESSED = gql`
    mutation markListingMetadataProcessed($listingId: uuid!, $type: String) {
        update_listing_metadata(
            where: { listing_id: { _eq: $listingId }, type: { _eq: $type } }
            _set: { is_processed: true }
        ) {
            affected_rows
        }
    }
`;

const DELIST_LISTING = gql`
    mutation delistListing($listingId: uuid!) {
        delist_from_all_portals(listingId: $listingId) {
            success
            error
        }
    }
`;

const GET_ALL_LISTINGS = gql`
    query getAllListings {
        listing(order_by: { updated_at: desc }) {
            id
            listing_onboardings {
                step_completed
            }
            orders {
                status
                processed_by_id
                order_items {
                    campaign_id
                }
            }
        }
    }
`;

const CREATE_EMPTY_LISTING_BY_ADMIN_MUTATION = gql`
    mutation createEmptyListingByAdmin($ownerId: uuid!, $portalStatuses: [listing_publish_status_insert_input!]!) {
        insert_listing(objects: { owner_id: $ownerId, listing_publish_statuses: { data: $portalStatuses } }) {
            affected_rows
            returning {
                id
                created_at
            }
        }
    }
`;

const LISTING_CREATED_AT = gql`
    query listingCreatedAt($listingId: uuid!) {
        listing_by_pk(id: $listingId) {
            created_at
        }
    }
`;
